export const SET_DEPOSIT_INFO = 'SET_DEPOSIT_INFO';